'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showAvailabilityMessageInWidget = undefined;

var _reselect = require('reselect');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _hasBotMessages = require('conversations-schema/thread-history/operators/hasBotMessages');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var _getCurrentThreadId = require('../../selectors/conversationSelectors/getCurrentThreadId');

var showAvailabilityMessageInWidget = exports.showAvailabilityMessageInWidget = (0, _reselect.createSelector)([_getCurrentChannel.getCurrentChannel, _getAssignedResponderInWidget.getAssignedResponderInWidget, _historyDataForThread.historyDataForThread, _getCurrentThreadId.getCurrentThreadId], function (currentChannel, assignedResponder, history, threadId) {
  var isInThreadView = currentChannel !== null;
  var isUnassigned = !assignedResponder;

  if (!history) {
    window.Raven.captureMessage('NO_HISTORY_FOUND_FOR_THREAD', {
      extra: {
        threadId: threadId
      },
      level: 'info'
    });
  }

  return isInThreadView && isUnassigned && Boolean(history) && (0, _hasMessages.hasMessages)(history) && !(0, _hasBotMessages.hasBotMessages)(history);
});


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/showAvailabilityMessageInWidget.js
// module id = 569
// module chunks = 2 3